import { Box, CardProps } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'

interface LoadingCardProps extends CardProps {
  size?: 'small' | 'large'
}

export const LoadingCard: React.FC<LoadingCardProps> = ({ size, className }) => {
  return (
    <>
      <Box width={size ? (size === 'small' ? 250 : 600) : 'inherit'} marginRight={0.5} my={5}>
        <Skeleton
          variant="rect"
          width={size ? (size === 'small' ? 250 : 600) : '100%'}
          height={160}
        />
        <Skeleton />
        <Skeleton width="60%" />
      </Box>
    </>
  )
}
